import { REQUIRED_LEVELS } from '../components/widgets/world/WorldMapConstants';
import * as browserStorage from '../misc/BrowserStorageManager';

export function getOrganizationLevel() {
   const userInfo = browserStorage.getUserInfo();
   return userInfo.accessLevel.code;
}

export function accessGranted(metric) {
   return getOrganizationLevel() >= REQUIRED_LEVELS[metric];
}
